import React, { useState } from 'react';
import axios from 'axios';
import { Base_URL } from '../../../apiConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderTitle from '../../dashboard/HeaderTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

const AddStreams = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    stream_name: '',
    created_by: 1,
  });
  const location = useLocation();
  const { mainTitle, subTitle } = location.state || {};
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.trimStart()
    }));
  };

  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    
    // Format date as DD-MM-YYYY
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Format time as HH:MM:SS
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    return {
      date: formattedDate,
      time: formattedTime
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const currentDateTime = new Date().toISOString();
      const { date, time } = formatDateTime(currentDateTime);

       // Trim all string fields in formData
       const trimmedFormData = Object.keys(formData).reduce((acc, key) => {
        acc[key] = typeof formData[key] === 'string' ? formData[key].trim() : formData[key];
        return acc;
    }, {});

    const dataToSubmit = {
        ...trimmedFormData,
    };

      await axios.post(`${Base_URL}/create/streams`, dataToSubmit, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Bearer ${token}`
        },
        withCredentials: true
      });

      toast.success('Stream added successfully!');
      // Reset form
      setFormData({
        stream_name: '',
        created_by: 1,
      });
    } catch (error) {
      toast.error('Failed to add stream.');
      console.error('Failed to add stream:', error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className="bg-gray-100 p-6 h-screen">
        <HeaderTitle mainTitle={mainTitle} subTitle={subTitle} />
        <div className="bg-white p-4 rounded-md">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4">
              <div className="flex flex-col">
                <label htmlFor="stream_name" className="mb-2 font-medium text-sm">Create Stream</label>
                <input
                  type="text"
                  id="stream_name"
                  name="stream_name"
                  value={formData.stream_name}
                  onChange={handleInputChange}
                  className="border border-gray-300 p-2 rounded"
                  required
                />
              </div>
            </div>

            <button 
              type="submit" 
              className="mt-6 px-4 py-2 bg-cmsgreen text-white rounded text-sm hover:bg-hovergreen"
              disabled={loading}
            >
              {loading ? (
                <div className="flex justify-center items-center">
                  <svg
                    className="animate-spin h-5 w-5 text-white mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                  Submitting...
                </div>
              ) : (
                'Add Stream'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStreams;
